export default __webpack_public_path__ + "static/media/hamburger.ef66fb20.png";